/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Comms/view.blocks to change it.
import Actions from './Actions/index'
import PatientCommsOverlay from 'DesignSystem/PatientComms/PatientCommsOverlay/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Comms({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/Comms"
  
}) {
  return (<React.Fragment
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
<PatientCommsOverlay
  viewPath={`${viewPath}/PatientCommsOverlay`}
/>
{children}
</React.Fragment>)
}